/*
 * @Author: lidan
 * @Date: 2021-01-21 15:47:16
 * @LastEditTime: 2021-01-21 15:53:49
 * @LastEditors: lidan
 * @Description: 需求竞价api
 * @FilePath: \e6-module-order-waybill-process\src\e6-module-order-waybill-process\api\demandBidding.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleOrderWaybillProcessApi } from "@/config/api";
const { host, E6_MS_TMS_BUSI_WEB } = e6ModuleOrderWaybillProcessApi;

/* ************** 需求竞价 **************** */
//需求竞价列表
export function listDemandBidding(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/inquiryPrice/list`,
    method: "post",
    data
  });
}

//需求竞价状态数量统计
export function countDemandBidding(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/inquiryPrice/count`,
    method: "post",
    data
  });
}

//报价/重新报价详情
export function priceDetails(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/inquiryPrice/priceDetails`,
    method: "post",
    data
  });
}

//需求详情(运单详情)
export function inquiryDetails(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/inquiryPrice/inquiryDetails`,
    method: "post",
    data
  });
}

//报价历史
export function priceHistory(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/inquiryPrice/priceHistory`,
    method: "post",
    data
  });
}

//报价/重新报价确认
export function priceConfirm(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/inquiryPrice/priceConfirm`,
    method: "post",
    data
  });
}

//取消报价
export function inquiryCancel(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/inquiryPrice/inquiryCancel`,
    method: "post",
    data
  });
}

//查看报价
export function inquiryShowPrice(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/inquiryPrice/showPrice`,
    method: "post",
    data
  });
}
